<sxw-side-dialog outletName="popups" theme="sxw-popup-cards">
  <h2>{{ "paymentMethod.editTitle" | translate }}</h2>
  <app-update-payment-method-form
    [paymentMethod]="paymentMethod"
    (onUpdatePaymentMethod)="updatePaymentMethod($event)"
    (onDeletePaymentMethod)="deletePaymentMethod()"
  ></app-update-payment-method-form>
</sxw-side-dialog>
